import type { ReactNode } from 'react'

export type EmptyStatePreviewState = 'default' | 'with-action' | 'no-action'

export const EMPTY_STATE_PREVIEW_STATES: EmptyStatePreviewState[] = [
  'default',
  'with-action',
  'no-action',
]

export const EMPTY_STATE_PREVIEW_STATE_LABELS: Record<
  EmptyStatePreviewState,
  string
> = {
  default: 'Default',
  'with-action': 'With action',
  'no-action': 'No action',
}

/** Empty state sample copy */
export const EMPTY_STATE_DEMO_TITLE = 'Empty page sample'
export const EMPTY_STATE_DEMO_DESCRIPTION = "There's no data to show here"
export const EMPTY_STATE_DEMO_ACTION_LABEL = 'Button'

export type EmptyStateProps = {
  title?: string
  description?: string
  /** Optional Mingcute icon class. When omitted, the default 88px Files illustration is used. */
  iconClass?: string
  /** Optional custom illustration instead of the default Files icon / `iconClass`. */
  illustration?: ReactNode
  actionLabel?: string
  onAction?: () => void
  className?: string
  /** Dark surface styling (aligned with Modal / DataTable empty). */
  darkMode?: boolean
  /** Draw a blue-200 border when the empty state sits on a matching blue-100 page background. */
  outlined?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: EmptyStatePreviewState
}
